<template>
  <div class="container is-fluid">
    <div class="columns">
      <div class="column">
        <p class="title is-1" align="center">Fitness History</p>
        <p class="title" align="center" id="categ"></p>

        <!-- Load Four Fitbit Categories -->
        <div v-if="mountView" class="columns is-centered">
          <div class="column">
            <radial-progress-bar
              :diameter="300"
              :completed-steps=10
              :total-steps=10
              :startColor="stepsColor"
              :stopColor="stepsColor">
              <p class="title" @click="processSelect('Steps')">Steps</p>
            </radial-progress-bar>
          </div>
          <div class="column">
            <radial-progress-bar
              :diameter="300"
              :completed-steps=10
              :total-steps=10
              :startColor="distanceColor"
              :stopColor="distanceColor">
              <p class="title" @click="processSelect('Distance')">Distance</p>
            </radial-progress-bar>
          </div>
          <div class="column">
            <radial-progress-bar
              :diameter="300"
              :completed-steps=10
              :total-steps=10
              :startColor="activeColor"
              :stopColor="activeColor">
              <p class="title" @click="processSelect('Active Minutes')">Active Minutes</p>
            </radial-progress-bar>
          </div>
          <div class="column">
            <radial-progress-bar
              :diameter="300"
              :completed-steps=10
              :total-steps=10
              :startColor="hrColor"
              :stopColor="hrColor">
              <p class="title" @click="processSelect('Heart Rate')">Heart Rate</p>
            </radial-progress-bar>
          </div>
        </div>

        <!-- Load Category Details -->
        <p v-if="detailView" class="button is-small is-fullwidth notification is-dark" @click="reloadPage">BACK</p>


        <div v-if="detailView" class="columns is-centered">
          <div class="column">
            <p class="title is-5" align="center">LAST MONTH</p>
            <div class="box">
              <div class="columns is-centered">
                <div class="column">
                    <p class="subtitle is-5 is-spaced" align="center">TOTAL</p>
                    <p class="subtitle is-6" align="center"> {{ tileObj[0].sum }} </p>
                    <p class="subtitle is-5 is-spaced" align="center">AVERAGE</p>
                    <p class="subtitle is-6" align="center"> {{ tileObj[0].avg }} </p>
                </div>
                <div class="column">
                  <p class="subtitle is-4" align="center">TOP 10</p><br>
                  <ol v-for="item in tileObj[0].sorted" class="subtitle is-6" align="center">
                    {{ item.dateTime }} - {{ item.value }}
                  </ol>
                </div>
              </div>
            </div>
          </div

          <!-- Populate Chart -->
          <div class="column is-half">
            <vue-slider
              v-model="sliderValue"
              v-bind="sliderOptions">
            </vue-slider><br>
            <div class="field has-addons">
              <p class="control is-expanded">
                <span class="button is-static is-fullwidth">{{ sliderValue }}</span>
              </p>
              <p class="control">
                <span class="button is-dark" @click="fillData(chartChangeData)">UPDATE CHART</span>
              </p>
            </div>
            <div class="small">
              <line-chart
                :chart-data="datacollection">
              </line-chart>
            </div>
          </div>

          <div class="column">
            <p class="title is-5" align="center">LAST YEAR</p>
            <div class="box">

              <div class="columns is-centered">
                <div class="column">
                    <p class="subtitle is-5 is-spaced" align="center">TOTAL</p>
                    <p class="subtitle is-6" align="center"> {{ tileObj[1].sum }} </p>
                    <p class="subtitle is-5 is-spaced" align="center">AVERAGE</p>
                    <p class="subtitle is-6" align="center"> {{ tileObj[1].avg }} </p>
                </div>
                <div class="column">
                  <p class="subtitle is-4" align="center">TOP 10</p><br>
                  <ol v-for="item in tileObj[1].sorted" class="subtitle is-6" align="center">
                    {{ item.dateTime }} - {{ item.value }}
                  </ol>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import LineChart from './LineChart.js'
  import vueSlider from 'vue-slider-component'

  export default {
    data () {
      return {
        sliderValue: 15,
        sliderOptions: {
          eventType: 'auto',
          width: 'auto',
          height: 10,
          dotSize: 16,
          dotHeight: null,
          dotWidth: null,
          min: 0,
          max: 30,
          interval: 1,
          show: true,
          speed: 0.5,
          disabled: false,
          piecewise: false,
          piecewiseStyle: false,
          piecewiseLabel: false,
          tooltip: false,
          tooltipDir: 'top',
          reverse: false,
          data: null,
          clickable: true,
          realTime: false,
          lazy: false,
          formatter: null,
          bgStyle: null,
          sliderStyle: null,
          processStyle: null,
          piecewiseActiveStyle: null,
          piecewiseStyle: null,
          tooltipStyle: null,
          labelStyle: null,
          labelActiveStyle: null
        },
        gradient: null,
        datacollection: null,
        chartChangeData: null,
        mountView: true,
        detailView: false,
        stepsColor: "#C0392B",
        distanceColor: "#7D3C98",
        calorieColor: "#27AE60",
        activeColor: "#2980B9",
        hrColor: "#66ff33",
        tileObj: [
          {'sorted': [], 'avg': 0, 'sum': 0},
          {'sorted': [], 'avg': 0, 'sum': 0}
        ]
      }
    },
    methods: {
      //Convert data from fitbit response to Chartjs friendly format
      fillData (val) {
        val = this.prepareData(val)

        this.datacollection = {
          labels: this.fillXAxis(val),
          datasets: [
            {
              label: document.getElementById('categ').innerHTML,
              borderColor: '#2a0d45',
              pointBackgroundColor: '#551a8b',
              borderWidth: 1,
              pointBorderColor: 'white',
              backgroundColor: '#9370DB',
              data: this.fillYAxis(val)
            }
          ]
        }
      },

      //Capture data for Y Axis
      fillYAxis(val) {
        var yAxis = []
        for (var key=(val.length-this.sliderValue); key<val.length; key++) {
          if (document.getElementById('categ').innerHTML == 'Heart Rate') {
            if (isNaN(val[key].value.restingHeartRate)) {
                yAxis.push(0)
            } else {
                yAxis.push(val[key].value.restingHeartRate)
            }
          } else {
            yAxis.push(val[key].value)
          }
        }
        return yAxis
      },

      //Capture data for X Axis
      fillXAxis(val) {
        var xAxis = []
        for (var key=(val.length-this.sliderValue); key<val.length; key++) {
          xAxis.push(val[key].dateTime)
        }
        return xAxis
      },

      //Reset page to original state
      reloadPage() {
        //Reset avg and sum values
        for (var key in this.tileObj) {
          this.tileObj[key].avg = 0
          this.tileObj[key].sum = 0
        }
        this.mountView = true
        this.detailView = false
        document.getElementById('categ').innerHTML=null
      },

      //Take fitbit return string and convert it to proper format and return JSON Object
      prepareData(val) {
        var c = ''
        if (document.getElementById('categ').innerHTML == 'Steps' ||
            document.getElementById('categ').innerHTML == 'Distance' ||
            document.getElementById('categ').innerHTML == 'Calories Burned' ||
            document.getElementById('categ').innerHTML == 'Active Minutes') {
          c = this.convertVal(document.getElementById('categ').innerHTML).split('/')[1]
          val = val.split(c+'\":')[1].split(']}')[0]+']'
        } else {
          c = this.convertVal(document.getElementById('categ').innerHTML)
          val = val.split(c+'\":')[1].split('}}]}')[0]+'}}]'
        }
        return JSON.parse(val)
      },

      //Convert val to format Fitbit Web API will recognize
      convertVal(val) {
        switch (val) {
          case 'Steps':
            return val = 'tracker/steps'
            break
          case 'Distance':
            return val = 'tracker/distance'
            break
          case 'Calories Burned':
            return val = 'tracker/activityCalories'
            break
          case 'Active Minutes':
            return val = 'tracker/minutesFairlyActive'
            break
          case 'Heart Rate':
            return val = 'heart'
            break
          default:
            console.log('processSelect val does not match any case')
            break
        }
      },

      //Request category data from Fitbit Web API
      processSelect(val) {
        let convert = ''
        convert = this.convertVal(val)

        document.getElementById('categ').innerHTML=val
        //Check for oauth access token stored in local cookies and
        //make axios http call for fitbit tracker data category
        //Else tell user to sync device
        if(this.$cookies.isKey('oauth_access_token')) {
          this.mountView = false
          this.detailView = true
          var AuthString = 'Bearer '+(this.$cookies.get('oauth_access_token'))
          axios.defaults.headers.common['Authorization'] = AuthString

          //Call for 1 month of data
          axios({ method: 'get',
            url: 'https://api.fitbit.com/1/user/-/activities/'+convert+'/date/today/1m.json'
          })
          .then(response => {
            this.chartChangeData = JSON.stringify(response.data)
            this.findTileData(JSON.stringify(response.data), 'month')
            this.fillData(JSON.stringify(response.data))
          })
          .catch(error => { console.log(error); })

          //Call for 1 year of data
          axios({ method: 'get',
            url: 'https://api.fitbit.com/1/user/-/activities/'+convert+'/date/today/1y.json'
          })
          .then(response => {
            this.findTileData(JSON.stringify(response.data), 'year')
          })
          .catch(error => { console.log(error); })
        } else {
          document.getElementById('categ').innerHTML='Please Sync Device To View Fitbit History'
        }
      },

      //Find all data to fill tile elements
      findTileData(val, tFrame) {
        let temp = 0
        let index = 4
        val = this.prepareData(val)

        //Set proper index in tile obj data element
        if (tFrame=='month'){
          index = 0
        } else if (tFrame=='year') {
          index = 1
        } else {
          console.log("Error in tile data index")
        }

        if (document.getElementById('categ').innerHTML == 'Steps' ||
            document.getElementById('categ').innerHTML == 'Distance' ||
            document.getElementById('categ').innerHTML == 'Calories Burned' ||
            document.getElementById('categ').innerHTML == 'Active Minutes') {
          //Sort fitbit data from high to low and populate top ten
          val.sort(function(a, b){
            return b.value-a.value
          })
          for (var i=0; i<10; i++) {
            this.tileObj[index].sorted[i] = {"dateTime": val[i].dateTime, "value": Number(parseInt(val[i].value)).toFixed(1)}
          }

          var count = 0
          //Find fitbit data sum and average
          //Only average days with more than zero
          //Zero assumes device not worn
          for (var key in val) {
            if (parseInt(val[key].value > 0)) {
              this.tileObj[index].sum += parseInt(val[key].value)
              count++
            }
          }
          this.tileObj[index].avg = Number(this.tileObj[index].sum / count).toFixed(0)
          count = 0
        } else {
          //Sort fitbit data from high to low and populate top ten
          val.sort(function(a, b) {
            if (!isFinite(b.value.restingHeartRate-a.value.restingHeartRate)) {
              return isFinite(b.value.restingHeartRate) ? 1 : -1
            } else {
              return b.value.restingHeartRate-a.value.restingHeartRate
            }
          })
          for (var i=0; i<10; i++) {
            this.tileObj[index].sorted[i] = {"dateTime": val[i].dateTime, "value": Number(parseInt(val[i].value.restingHeartRate)).toFixed(1)}
          }

          var count = 0
          //Find fitbit data sum and average
          //Only average days with data
          //No data assumes device not worn
          for (var key in val) {
            if (isNaN(val[key].value.restingHeartRate)) {
            } else {
              this.tileObj[index].sum += parseInt(val[key].value.restingHeartRate)
              count++
            }
          }
          this.tileObj[index].avg = Number(this.tileObj[index].sum / count).toFixed(0)
          this.tileObj[index].sum = 'N/A'
          count = 0
        }
      },
    },
    components: {
      LineChart,
      vueSlider
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.small {
  max-width: 600px;
  background: #c3bdb2;
  border-radius: 10px;
  box-shadow: 0px 2px 15px rgba(25, 25, 25, 0.27);
  margin:  25px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Fitness/FitnessHistory.vue